import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'

// components
import Typography from '@mui/material/Typography'

const LegacyDietaryRestrictionsWarning = props => {
  const { dietaryRestrictions, camperRestrictions } = props

  const removed = camperRestrictions
    .filter(name => dietaryRestrictions.map(r => r.name).indexOf(name) === -1)
    .join(', ')

  return (
    <Box mt={4} mb={2}>
      <Card>
        <CardContent>
          <Typography paragraph color='error.main' fontWeight='fontWeightBold'>
            We have changed the way we specify Dietary Restrictions. Please note
            that dietary restrictions are different from food allergies. Please
            update the form below with current dietary restriction information.
            We removed the following categories you previously selected:
          </Typography>
          <Typography>{removed}</Typography>
        </CardContent>
      </Card>
    </Box>
  )
}

export default LegacyDietaryRestrictionsWarning
